/* eslint-disable react/jsx-pascal-case */
import React, { Suspense, useEffect, useState }  from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Outlet, useParams, Navigate } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
// import 'primereact/resources/themes/bootstrap4-light-blue/theme.css'
import 'primereact/resources/themes/fluent-light/theme.css'
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";  
import routes from './routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from './store';
import FadeIn from 'react-fade-in'
import { createTheme  } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CreatePath from "./components/CreatePath";
// import Login from './components/Login';
import LoginUserSendMail from "./components/Login-User/SendMail";
import LoginUserSendMailSuccess from "./components/Login-User/SendMailSuccess";
import LoginUserVerifySuccess from "./components/Login-User/VerifySuccess";
import LoginUserChangePassword from "./components/Login-User/ChangePassword";
// import ThemeColor from "./components/ThemeColor";
import Error404 from "./components/Error404";
import Error403 from "./components/Error403";
import Navbar from './layouts/Navbar';
import TermAndCondition from "./components/Login-User/TermAndCondition";
import LoadingComponent from './lib/LoadingComponent';
import Login from './components/Login';
import LoginUser from './components/Login-User/LoginUser';
import ThemeColor from './components/ThemeColor';

import CookieConsent, { Cookies } from "react-cookie-consent";
import fontColor from './lib/fontColor';
import { useCookies } from 'react-cookie';
import Completed from './components/Completed';
import EduPortalManagement from './components/Service/EduPortalManagement';
import ErrorNoInternet from './components/ErrorNoInternet';
// import LoginMobile from './components/Home/loginMobile';
import { Offline, Online } from "react-detect-offline";
import RedirectOne from './components/RedirectOne';
import RegisterRoute from './components/Login-User/RegisterRoute';
import AuthenticateRoute from './lib/AuthenticateRoute';

axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));

const SetTiTle = ({children}) => {
  const params = useParams()
  React.useEffect(() => {
    document.title = params.prefix ? params.prefix.toUpperCase() : 'One ID UM'
  }, []);
  return children;
}

const CookieConsentComponent = () => {
  return (
    <CookieConsent
    location="bottom"
    buttonText="ยอมรับทั้งหมด"      
    cookieName="cookie_consent_accepting"
    style={{ background: "#2B373B", zIndex: '10000' }}
    buttonStyle={{ color: fontColor('rgb(246,145,31)'), fontSize: "13px", background: 'rgb(246,145,31)' }}
    expires={150}
    onAccept={() => {
      // window.location.reload()
    }}
    >
      <span 
      style={{ 
        fontSize: "13px",
      }}
      >
        เราใช้คุกกี้เพื่อเพิ่มประสิทธิภาพ และประสบการณ์ที่ดีในการใช้งานเว็บไซต์ เมื่อคุณกดยอมรับเราจะสามารถเลือกแสดงสิ่งที่น่าสนใจสำหรับคุณได้โดยเฉพาะ
      </span>
    </CookieConsent>
  )
}
const Providers = ({children}) => {
  useEffect(() => {
    document.title = 'One ID UM';
  }, []);

  const THEME = createTheme ({
    typography: {
     "fontFamily": `"Sarabun", sans-serif !important',`,
    }
  });
  const errorPage = <ErrorNoInternet />
  return (
      <ThemeProvider theme={THEME}>
        <FadeIn>
            <Provider store={store}>
              <BrowserRouter>
                <Routes>
                  {children}
                </Routes>
              </BrowserRouter>
            </Provider>
            <CookieConsentComponent />
        </FadeIn>
      </ThemeProvider>
  )

}


root.render(
  <Providers>
  

    <Route path="/">
      <Route element={<> <SetTiTle><Login /></SetTiTle></>} path="/" />
      <Route element={ <SetTiTle><Suspense fallback={<LoadingComponent />}><SetTiTle><LoginUser /></SetTiTle></Suspense></SetTiTle>} path="/:prefix" />
      <Route element={<SetTiTle><Suspense fallback={<LoadingComponent />}><RegisterRoute /></Suspense></SetTiTle>} path="/:prefix/register" />
      <Route element={<><SetTiTle><RedirectOne /></SetTiTle></>} path="/redirect-one" />
    </Route>
    
    <Route path="/">
      <Route element={<SetTiTle><Outlet/></SetTiTle>} path="/" ></Route>
    </Route>

    {/* <Route path="/">
      <Route element={<SetTiTle><LoginMobile/></SetTiTle>} path="/mobile" ></Route>
    </Route> */}
    
    <Route path="/" element={<SetTiTle><AuthenticateRoute><Outlet/></AuthenticateRoute></SetTiTle>}>
      <Route path="/:prefix/login-user"><Route element={ <SetTiTle><Suspense fallback={<LoadingComponent />}><LoginUser /></Suspense></SetTiTle>} path="/:prefix/login-user" /></Route>
      <Route path="/:prefix/login-user/send-mail"><Route element={<><SetTiTle><LoginUserSendMail /></SetTiTle></>} path="/:prefix/login-user/send-mail" /></Route>
      <Route path="/:prefix/login-user/send-mail/success"><Route element={<><SetTiTle><LoginUserSendMailSuccess /></SetTiTle></>} path="/:prefix/login-user/send-mail/success" /></Route>
      <Route path="/:prefix/login-user/verify-success"><Route element={<><SetTiTle><LoginUserVerifySuccess /></SetTiTle></>} path="/:prefix/login-user/verify-success" /></Route>
      <Route path="/:prefix/login-user/ChangePassword"><Route element={<><SetTiTle><LoginUserChangePassword /></SetTiTle></>} path="/:prefix/login-user/ChangePassword" /></Route>
      <Route path="/login-user/term-and-condition"><Route element={<><SetTiTle><TermAndCondition /></SetTiTle></>} path="/login-user/term-and-condition" /></Route>
      <Route element={<SetTiTle><CreatePath /></SetTiTle>} path="/businesses/management" />
      <Route element={<SetTiTle><LoginUserChangePassword /></SetTiTle>} path="/:prefix/login-user/change-password" />
      <Route element={<SetTiTle><Completed /></SetTiTle>} path="/:prefix/completed" />
      <Route path="/theme_color">
        <Route element={<SetTiTle><ThemeColor /></SetTiTle>} path="/theme_color" />
      </Route>
      <Route element={<SetTiTle><Navbar /></SetTiTle>}>
        {routes.map((route, index) => <Route key={index} {...route} element={route.component} path={route.path} />)}
      </Route>
      <Route path="*" element={ <SetTiTle><Error404 /></SetTiTle>} />
      <Route path="/forbidden" element={ <SetTiTle><Error403 /></SetTiTle>} />
    </Route>
    <Route path="/notfound" element={ <SetTiTle><Error404 /></SetTiTle>} />
  </Providers>
);
reportWebVitals();